import { render, staticRenderFns } from "./rightPage.vue?vue&type=template&id=3d20d2cf&scoped=true&"
import script from "./rightPage.vue?vue&type=script&lang=js&"
export * from "./rightPage.vue?vue&type=script&lang=js&"
import style0 from "./rightPage.vue?vue&type=style&index=0&id=3d20d2cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d20d2cf",
  null
  
)

export default component.exports